export const SET_CENTER = 'dashboard/Map/SET_CENTER'
export const SET_ZOOM = 'dashboard/Map/SET_ZOOM'
export const SET_MARKER = 'dashboard/Map/SET_MARKER'
export const SET_MAP_INSTANCE = 'dashboard/Map/SET_MAP_INSTANCE'
export const SET_DATA_TYPE = 'dashboard/Map/SET_DATA_TYPE'
export const SET_BOUNDS = 'dashboard/Map/SET_BOUNDS'
